<!-- 遮罩层 -->
<div class="intelligent-qa-mask" *ngIf="showIntelligentQa">
</div>
<!-- 智能客服弹窗 -->
<section *ngIf="showIntelligentQa" class="intelligent-qa-container" [class.simple-mode]="SWITCH.IS_SIMPLE_MODE">
    <!-- 右上角小X -->
    <span class="close-btn" (click)="close()">
        <svg class="icon">
            <use xlink:href="#icon-close"></use>
        </svg>
    </span>
    <!-- 标题 -->
    <h2 class="header">{{i18n.intelligentCustomerServiceLab}}</h2>
    <!-- 功能介绍 -->
    <div>
        <p class="tip-text">{{i18n.intelligentCustomerServiceTip}}</p>
    </div>
    <div class="qrcode-content">
        <div class="intelligent-qa-box">
            <!-- 智能客服二维码 -->
            <div class="img-box">
                <span class="refesh-btn" (click)="refreshPolling()"></span>
                <div class="qrcode-img" [innerHTML]="(qrOutput | safeHtml)"></div>
                <div class="lab-text-qrcode">{{i18n.intelligentCustomerServiceQrcode}}</div>
                <n-loading [visible]="loading"></n-loading>
            </div>
            <!-- 前往智能客服页面 -->
            <div class="img-box qa-box">
                <a [href]="qrcodeUrl" target="_blank">
                    <div [class]="'intelligent-qa-img'"></div>
                    <div class="lab-text">
                        <span>{{i18n.intelligentCustomerServiceHyperlink}}</span>
                        <div class="arrowhead"></div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</section>